// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"fe33e10c","769":"43583758"}[chunkId] + ".chunk.css";
};